import styled, { css } from 'styled-components'

export const RowFlex = css`
    display: flex;
    flex-direction: row;
`

export const ColumnFlex = css`
    display: flex;
    flex-direction: column;
`

export const FlexJustifyContentCenter = css`
    display: flex;
    justify-content: center;
`

export const FlexJustifyContentSpaceBetween = css`
    display: flex;
    justify-content: space-between;
`

export const FlexAlignItemsCenter = css`
    display: flex;
    align-items: center;
`

export const FlexCentered = css`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const AbsolutePositioning = css`
    position: absolute;
    margin: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`

export const FullWidthHeight = css`
    width: 100%;
    height: 100%;
`

export const preventDraggable = `
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
`

export const customScrollBar = `
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f117;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 20px;
        cursor: drag;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`

export const hideWhenNoChildren = css`
    &:empty {
        display: none;
    }
`

export const Square = {
    Area: styled.div`
        height: 0;
        padding-top: 100%;
        position: relative;
        width: 100%;
        margin: 5% 0px;
        ${props => props.$css}
    `,
    Wrapper: styled.div`
        ${AbsolutePositioning}
        width: 100%;
        height: 100%;
        ${props => props.$css}
    `,
}
